export const menuWidth = '300px';
export const headerHeight = '110px';
